import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Input, Card } from "@/components/erp/ui";

const err = (e) => toast.error(e?.response?.data?.detail || "Gagal");

// Ganti nama item stok: wajib PIN, lalu menunggu persetujuan admin utama (juga dengan PIN)
export const RenameStockModal = ({ name, onClose, onDone }) => {
  const [nv, setNv] = useState(name || ""); const [pin, setPin] = useState("");
  useEffect(() => { setNv(name || ""); setPin(""); }, [name]);
  const send = async () => { try { await api.post("/stock/rename-request", { old_name: name, new_name: nv, pin }); toast.success("Pengajuan ganti nama dikirim ke admin utama"); onDone(); onClose(); } catch (e) { err(e); } };
  return (
    <Modal open={!!name} onClose={onClose} title={`Ganti nama: ${name || ""}`}
      footer={<><Btn variant="ghost" onClick={onClose}>Batal</Btn><Btn data-testid="stock-rename-send" disabled={!nv.trim() || nv.trim() === name || pin.length < 4} onClick={send}>Ajukan</Btn></>}>
      <div className="space-y-2" data-testid="stock-rename-modal">
        <Input data-testid="stock-rename-new" value={nv} onChange={(e) => setNv(e.target.value)} placeholder="Nama baru" />
        <Input data-testid="stock-rename-pin" type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} placeholder="PIN keamanan Anda *" />
        <p className="text-[11px] text-slate-500">Semua varian dengan nama ini + PR &amp; PO ikut berganti setelah admin utama menyetujui (dengan PIN).</p>
      </div>
    </Modal>
  );
};

export const RenameRequests = ({ tick, onDone }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/stock/rename-requests").then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, [tick]);
  if (!d?.rows.length) return null;
  const decide = async (r, approve) => {
    const pin = window.prompt(`${approve ? "Setujui" : "Tolak"} ganti nama "${r.old_name}" → "${r.new_name}"?\nMasukkan PIN admin utama:`);
    if (!pin) return;
    try { const { data } = await api.post(`/stock/rename-requests/${r.id}/decide`, { approve, pin }); toast.success(approve ? `Disetujui — ${data.updated} item diganti` : "Ditolak"); load(); onDone(); } catch (e) { err(e); }
  };
  return (
    <Card className="p-3 mb-3 border-amber-200 bg-amber-50/60" data-testid="stock-rename-requests">
      <div className="text-sm font-semibold mb-1">Pengajuan ganti nama item ({d.rows.length})</div>
      {d.rows.map((r) => (
        <div key={r.id} className="flex flex-wrap items-center gap-2 text-xs py-1 border-t border-amber-100" data-testid={`stock-rename-req-${r.id}`}>
          <span className="flex-1 min-w-[200px]"><b>{r.old_name}</b> → <b>{r.new_name}</b> · {r.by} · {new Date(r.at).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" })}</span>
          {d.can_decide ? <><Btn data-testid={`stock-rename-approve-${r.id}`} onClick={() => decide(r, true)}>Setujui</Btn><Btn variant="ghost" data-testid={`stock-rename-reject-${r.id}`} onClick={() => decide(r, false)}>Tolak</Btn></> : <span className="text-amber-700">menunggu admin utama</span>}
        </div>))}
    </Card>
  );
};
